import { mapEnumToOptions } from '@abp/ng.core';

export enum EventTypeDefinition {
  STANDARD = 'STANDARD',
  JOBSITE = 'JOBSITE',
}

export const eventTypeDefinitionOptions = mapEnumToOptions(EventTypeDefinition);
